export const imgArray = {
    julia: [
        '/img/julia/Slide1.png',
        '/img/julia/Slide2.png',
        '/img/julia/Slide3.png',
        '/img/julia/Slide4.png',
        '/img/julia/Slide5.png',
        '/img/julia/Slide6.png',
        '/img/julia/Slide7.png',
        '/img/julia/Slide8.png',
        '/img/julia/Slide9.png',
        '/img/julia/Slide10.png',
        '/img/julia/Slide11.png',
    ],
    nadia: [
        '/img/nadia/Slide1.png',
        '/img/nadia/Slide2.png',
        '/img/nadia/Slide3.png',
        '/img/nadia/Slide4.png',
        '/img/nadia/Slide5.png',
        '/img/nadia/Slide6.png',
        '/img/nadia/Slide7.png',
        '/img/nadia/Slide8.png',
        '/img/nadia/Slide9.png',
        '/img/nadia/Slide10.png',
        '/img/nadia/Slide11.png',
    ],
    diana: [
        '/img/diana/Slide1.png',
        '/img/diana/Slide2.png',
        '/img/diana/Slide3.png',
        '/img/diana/Slide4.png',
        '/img/diana/Slide5.png',
        '/img/diana/Slide6.png',
        '/img/diana/Slide7.png',
        '/img/diana/Slide8.png',
        '/img/diana/Slide9.png',
        '/img/diana/Slide10.png',
    ],
    daniela: [
        '/img/daniela/Slide1.png',
        '/img/daniela/Slide2.png',
        '/img/daniela/Slide3.png',
        '/img/daniela/Slide4.png',
        '/img/daniela/Slide5.png',
        '/img/daniela/Slide6.png',
        '/img/daniela/Slide7.png',
        '/img/daniela/Slide8.png',
        '/img/daniela/Slide9.png',
        '/img/daniela/Slide10.png',
    ],
}

export const mobileArray = {
    julia: [
        '/img/mobile/julia/Slide1.png',
        '/img/mobile/julia/Slide2.png',
        '/img/mobile/julia/Slide3.png',
        '/img/mobile/julia/Slide4.png',
        '/img/mobile/julia/Slide5.png',
        '/img/mobile/julia/Slide6.png',
        '/img/mobile/julia/Slide7.png',
        '/img/mobile/julia/Slide8.png',
        '/img/mobile/julia/Slide9.png',
        '/img/mobile/julia/Slide10.png',
        '/img/mobile/julia/Slide11.png',
    ],
    nadia: [
        '/img/mobile/nadia/Slide1.png',
        '/img/mobile/nadia/Slide2.png',
        '/img/mobile/nadia/Slide3.png',
        '/img/mobile/nadia/Slide4.png',
        '/img/mobile/nadia/Slide5.png',
        '/img/mobile/nadia/Slide6.png',
        '/img/mobile/nadia/Slide7.png',
        '/img/mobile/nadia/Slide8.png',
        '/img/mobile/nadia/Slide9.png',
        '/img/mobile/nadia/Slide10.png',
        '/img/mobile/nadia/Slide11.png',
    ],
    diana: [
        '/img/mobile/diana/Slide1.png',
        '/img/mobile/diana/Slide2.png',
        '/img/mobile/diana/Slide3.png',
        '/img/mobile/diana/Slide4.png',
        '/img/mobile/diana/Slide5.png',
        '/img/mobile/diana/Slide6.png',
        '/img/mobile/diana/Slide7.png',
        '/img/mobile/diana/Slide8.png',
        '/img/mobile/diana/Slide9.png',
        '/img/mobile/diana/Slide10.png',
    ],
    daniela: [
        '/img/mobile/daniela/Slide1.png',
        '/img/mobile/daniela/Slide2.png',
        '/img/mobile/daniela/Slide3.png',
        '/img/mobile/daniela/Slide4.png',
        '/img/mobile/daniela/Slide5.png',
        '/img/mobile/daniela/Slide6.png',
        '/img/mobile/daniela/Slide7.png',
        '/img/mobile/daniela/Slide8.png',
        '/img/mobile/daniela/Slide9.png',
        '/img/mobile/daniela/Slide10.png',
    ],
}